import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { CompanyMemberAccess } from 'contracts/CompanyMemberAccesses';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_COMPANY_MEMBER_ACCESS_',
  }
);

export interface FetchCompanyMemberAccessState {
  data: CompanyMemberAccess | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchCompanyMemberAccessRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: CompanyMemberAccess;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchCompanyMemberAccessState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchCompanyMemberAccessState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchCompanyMemberAccessState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchCompanyMemberAccessState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchCompanyMemberAccessState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchCompanyMemberAccess = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchCompanyMemberAccessTypes = Types;
export const FetchCompanyMemberAccessActions = Creators;
